import React, { Component } from 'react';

import ConversationList from './ConversationList.js';
import FullscreenDialog from '@material-ui/core/Dialog';
import FlatButton from 'material-ui/FlatButton';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';

import CloseIcon from 'material-ui/svg-icons/navigation/close';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

export default class ConversationDialog extends Component {
  UNSAFE_componentWillMount() {
    this.setState({ open: false });
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div>
        <FlatButton
          label="View All Conversations"
          onClick={this.handleOpen}
          style={{ background: '#fff', color: AccentColor(), width: '100%' }}
        />

        <FullscreenDialog fullScreen open={this.state.open} onClose={this.handleClose}>
          <AppBar>
            <Toolbar style={{ textAlign: 'center', backgroundColor: 'white' }}>
              <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <h3 style={{ margin: 'auto', paddingRight: '40px', color: colors.DARK_GRAY }}>
                All Conversations
              </h3>
            </Toolbar>
          </AppBar>
          <div style={{ marginTop: '50px' }}>
            <ConversationList
              style={{ width: '100%', height: '100%' }}
              userType={this.props.userType}
              conversations={this.props.conversations}
              fetchConversations={this.props.fetchConversations}
              activeConversation={this.props.activeConversation}
              setActiveConversation={this.props.setActiveConversation}
              properties={this.props.properties}
              getProperties={this.props.getProperties}
              createPropertyNotification={this.props.createPropertyNotification}
              handleClose={this.handleClose}
            />
          </div>
        </FullscreenDialog>
      </div>
    );
  }
}
